import { Dispatch, SetStateAction, useRef, useState } from "react";
import GoogleTranslationComponent from "../googleTranslate/GoogleTranslationComponent";
import HexagonInput from "@/common/customElements/HexagonInput";
import { InlineDiv } from "@/common/divs";
import { AlmostBoldText, RegularText } from "@/common/texts";
import { CustomField } from "@/model";
import { NEUTRO_PARAGRAPHS_COLOR } from "@/utils/constants";
interface SelectUniqueOptionProps {
  elements: any[];
  typeOfCustomField: "SCHEDULE" | "TARIFF";
  scheduleCustomFields?: { pk: number; value: string | number | boolean }[];
  tariffCustomFields?: any;
  index: number;
  secondaryIndex?: number;
  objectKey?: string;
  type?: string;
  isRequired?: boolean;
  title?: string;
  name?: string;
  primaryPk?: number;
  setRequiredMissingScheduledFields?: Dispatch<SetStateAction<number>>;
  setRequiredMissingTariffFields?: Dispatch<SetStateAction<number>>;
  field?: CustomField;
}

const SelectUniqueOption: React.FC<SelectUniqueOptionProps> = ({
  elements,
  typeOfCustomField,
  scheduleCustomFields,
  tariffCustomFields,
  index,
  secondaryIndex,
  objectKey,
  type,
  isRequired,
  title,
  primaryPk,
  name,
  setRequiredMissingScheduledFields,
  setRequiredMissingTariffFields,
  field,
}) => {
  const [imSelected, setImSelected] = useState<string | null>(null);
  const updated = useRef(false);
  const getOptionId = (element: CustomField, elementIndex: number) => {
    return `${typeOfCustomField}-${objectKey ?? "default"}-${index}-${secondaryIndex ?? 0}-${elementIndex}-${element.name ?? "option"}`;
  };

  const handleUpdateCustomFields = (element: CustomField) => {
    if (typeOfCustomField == "SCHEDULE" && scheduleCustomFields) {
      if (element.name == "No") {
        scheduleCustomFields[index] = {
          pk: type == "extended-option" ? primaryPk : elements[0].pk,
          value: type == "extended-option" ? elements[0].pk : false,
        };
      } else {
        scheduleCustomFields[index] = {
          pk: type == "extended-option" ? (primaryPk ?? 0) : (element.pk ?? 0),
          value: type == "extended-option" ? (element.pk ?? "") : true,
        };
      }
      if (isRequired && !updated.current && setRequiredMissingScheduledFields) {
        setRequiredMissingScheduledFields((prevState) => prevState - 1);
        updated.current = true;
      }
    }

    const comp =
      secondaryIndex && tariffCustomFields && typeOfCustomField === "TARIFF";
    if (
      (typeOfCustomField == "TARIFF" && tariffCustomFields && secondaryIndex) ||
      comp == 0
    ) {
      if (element.name == "No") {
        tariffCustomFields[objectKey ?? ""][index][secondaryIndex ?? 0] = {
          ...field,
          pk: type == "extended-option" ? primaryPk : elements[0].pk,
          value: type == "extended-option" ? element.pk : false,
          type: type ?? "extended-option",
          isRequired: isRequired ?? false,
          title: title ?? "",
          name: name ?? "",
        };
      } else {
        tariffCustomFields[objectKey ?? ""][index][secondaryIndex ?? 0] = {
          ...field,
          pk: type == "extended-option" ? primaryPk : (element.pk ?? 0),
          value: type == "extended-option" ? (element.pk ?? "") : true,
          type: type ?? "extended-option",
          isRequired: isRequired ?? false,
          title: title ?? "",
          name: name ?? "",
        };
      }
      if (isRequired && !updated.current && setRequiredMissingTariffFields) {
        setRequiredMissingTariffFields((prevState) => prevState - 1);
        updated.current = true;
      }
    }
  };

  return (
    <InlineDiv className="inline-modal-div">
      {elements.map((element, elementIndex) => {
        const optionId = getOptionId(element, elementIndex);

        return (
          <InlineDiv key={optionId} style={{ width: "245px" }}>
            <HexagonInput
              onClick={() => {
                setImSelected(optionId);
                handleUpdateCustomFields(element);
              }}
              checked={imSelected === optionId}
            />
            <RegularText
              fontSize="14px"
              style={{
                marginLeft: "5px",
                color: NEUTRO_PARAGRAPHS_COLOR,
              }}
            >
              {element.name == "No" ?
                "No"
              : element.name == "🇬🇧 English" ?
                element.name
              : <GoogleTranslationComponent text={element.name} />}
            </RegularText>
            {field?.percentage ?
              field.percentage > 0 ?
                <AlmostBoldText
                  fontSize="14px"
                  style={{
                    marginLeft: "5px",
                    color: NEUTRO_PARAGRAPHS_COLOR,
                  }}
                >
                  {field.percentageFormatted}
                </AlmostBoldText>
              : null
            : null}
          </InlineDiv>
        );
      })}
    </InlineDiv>
  );
};

export default SelectUniqueOption;
